// how long to wait after a query is done changing to issue the request
export const QUERY_CHANGE_DELAY = 800;
